import React from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { ContactLoginHistory } from '@/modules/contact/ContactLoginHistory';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { useAuthStore } from '@/modules/user/stores';

const ContactLoginHistoryPage = () => {
  const { user } = useAuthStore();

  useBreadcrumbs([
    {
      route: ROUTES.CONTACT_LOGIN_HISTORY,
      title: 'Contacts Authentication History',
    },
  ]);

  if (!user) {
    return (
      <Box width="100%" justify="center" align="center">
        <Preloader />
      </Box>
    );
  }

  return (
    <Box width="100%" height="fit-content">
      <ContactLoginHistory />
    </Box>
  );
};

export default ContactLoginHistoryPage;
